import React from 'react'

export const Logo = () => <img src={'https://assets.nobroker.in/static/img/logos/nb_logo_new_trans.svg'} alt="NoBroker" />
